export default "__VITE_ASSET__494ee441__"